import fetchPartnerData from './fetch-partner-data';

export default {
  fetchPartnerData,
};
